import { useTranslation } from "react-i18next";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "ui";

import { useAuthContext } from "src/auth";
import { CurrentUserAvatar } from "src/components/CurrentUserAvatar";

export function LogoutMenu() {
  const authContext = useAuthContext();
  const { t } = useTranslation();

  const avatar = <CurrentUserAvatar />;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>{avatar}</DropdownMenuTrigger>
      <DropdownMenuContent className="mr-4">
        <DropdownMenuLabel className="flex gap-4 items-center">
          <div>{avatar}</div>
          <div className="flex flex-col">
            <span>{authContext.store.user.name}</span>
            <span className="text-xs font-normal">
              {authContext.store.user.email}
            </span>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <form action="/logout" method="post">
          <DropdownMenuItem asChild>
            <button className="w-full cursor-pointer" type="submit">
              {t("logOut")}
            </button>
          </DropdownMenuItem>
        </form>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
